export const defaultHeadingStyles="rui:font-bold rui:text-black-900 rui:dark:text-black-100";